document.documentElement.classList.remove('no-js');

// Smooth scroll for any "#tidal-buy" link (buttons that jump to the add to cart box)
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('a[href^="#tidal-buy"]');
  if (!a) return;
  var target = document.getElementById('tidal-buy');
  if (!target) return;
  e.preventDefault();
  var header = document.querySelector('.tidal-hd');
  var offset = header && getComputedStyle(header).position === 'sticky' ? header.offsetHeight : 0;
  window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - offset - 12, behavior: 'smooth' });
});
